import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { inquireNPSThunk } from "./nps.thunk";

export interface NPSState {
  audience_group_id: number | undefined;
  show_overall_nps: boolean;
}

export const InitialNPSState: NPSState = {
  audience_group_id: undefined,
  show_overall_nps: false,
};

const NPSSlice = createSlice({
  name: "NPSSlice",
  initialState: InitialNPSState,
  reducers: {
    setNPSStatus(state, action: PayloadAction<NPSState>) {
      state.audience_group_id = action.payload.audience_group_id;
      state.show_overall_nps = action.payload.show_overall_nps;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(inquireNPSThunk.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

export const NPSReducer = NPSSlice.reducer;
export const NPSActions = NPSSlice.actions;
